import {redeemScan} from '@/services/redeemScan.js'

/**
 * Loading every OTA Extra in an OTA group in one action (POST
 * /api/v3/scan/transfer-group), worded for the rep. A retry after a lost
 * response is answered with the first answer's counts.
 */
const GROUP_ENDPOINT = '/api/v3/scan/transfer-group'

const dict = () => (typeof __DICT__ !== 'undefined' ? __DICT__.scan?.groupLoad : null) || {}

/** English defaults; a brand dictionary can override any under scan.groupLoad. */
const MESSAGES = {
    loaded: '{loadedCount} loaded',
    loadedSomeOn: '{loadedCount} loaded, {alreadyLoaded} already on',
    allLoaded: 'Everyone in this group is already loaded',
    noneToLoad: 'No one in this group can be loaded',
    ...dict(),
}

const fill = (template, counts) => template.replace(/\{(\w+)\}/g, (_, name) => counts[name])

export function groupLoadMessage(counts) {
    if (counts.loadedCount === 0) return MESSAGES.allLoaded
    return fill(counts.alreadyLoaded > 0 ? MESSAGES.loadedSomeOn : MESSAGES.loaded, counts)
}

/**
 * @param {object} payload groupId, idempotentId, weekId, transferId, direction, repID, repName, handsetTimestamp, loadLat, loadLon
 * @param {object} [options] passed to redeemScan
 * @returns {Promise<{loadedCount: number, alreadyLoaded: number, message: string}>}
 *   throws an Error with `code` and a message to show
 */
export async function loadOtaGroup(payload, options) {
    let result
    try {
        result = await redeemScan(GROUP_ENDPOINT, payload, options)
    } catch (error) {
        if (error?.code === 'ticket_not_found') error.message = MESSAGES.noneToLoad
        throw error
    }
    const {loadedCount = 0, alreadyLoaded = 0} = result.response ?? result.original ?? {}
    const counts = {loadedCount, alreadyLoaded}
    return {...counts, message: groupLoadMessage(counts)}
}
